import { render, staticRenderFns } from "./StudentPostCreate.vue?vue&type=template&id=46588bbc&scoped=true&"
import script from "./StudentPostCreate.vue?vue&type=script&lang=js&"
export * from "./StudentPostCreate.vue?vue&type=script&lang=js&"
import style0 from "./StudentPostCreate.vue?vue&type=style&index=0&id=46588bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46588bbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
